<template>
  <a-modal
    :visible="visible"
    title="修改密码"
    :footer="null"
    @cancel="$emit('cancel')"
  >
    <div class="my-4">
      <a-form>
        <div class="flex flex-col gap-2">
          <a-form-item>
            <a-input-password
              visibilityToggle
              v-model="pwd1"
              placeholder="请输入密码"
            />
          </a-form-item>
          <a-form-item>
            <a-input-password
              visibilityToggle
              v-model="pwd2"
              placeholder="请重复输入密码"
            />
          </a-form-item>
        </div>
        <a-form-item>
          <div class="overflow-hidden">
            <div class="float-left" style="width: calc(100% - 160px)">
              <a-input v-model="sms"> </a-input>
            </div>
            <div class="float-right pt-1 overflow-hidden">
              <a-button
                class="float-right"
                style="width: 150px"
                :loading="sms_loading"
                :disbled="isStart"
                @click="sendCode"
                >{{
                  isStart ? `${currentCount}s后重新获取` : '获取验证码'
                }}</a-button
              >
            </div>
          </div>
        </a-form-item>
        <a-form-item>
          <a-button
            class="mr-6"
            type="primary"
            :loading="login_loading"
            :disabled="!sms || pwd1 != pwd2"
            @click="handleSubmit"
            >确定</a-button
          >
          <a-button @click="$emit('cancel')">取消</a-button>
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import { sendSmscode, modify_pw } from '@/api/user';
import { passwordStrength } from 'check-password-strength';
export default {
  props: {
    visible: Boolean,
    phone: String,
    id: Number,
  },
  data() {
    return {
      login_loading: false,
      sms_loading: false,
      codetips: '获取验证码',
      timerId: null,
      isStart: false,
      currentCount: 60,
      pwd1: '',
      pwd2: '',
      sms: '',
    };
  },
  methods: {
    async sendCode() {
      await sendSmscode({ tel: this.phone });
      this.start();
    },
    start() {
      if (this.isStart || !!this.timerId) {
        return;
      }
      this.isStart = true;
      this.timerId = setInterval(() => {
        if (this.currentCount === 1) {
          this.stop();
          this.currentCount = 60;
        } else {
          this.currentCount -= 1;
        }
      }, 1000);
    },
    stop() {
      this.isStart = false;
      this.clear();
      this.timerId = null;
    },
    clear() {
      this.timerId && window.clearInterval(this.timerId);
    },
    async handleSubmit() {
      if (this.pwd1 !== this.pwd2) {
        this.$message.warning('请输入相同的密码');
        return;
      }
      if (passwordStrength(this.pwd1).id == 0) {
        this.$message.error('请输入大于6位并包含数字及字母的密码');
        return;
      }
      try {
        this.login_loading = true;
        await modify_pw({
          id: this.id,
          phone_number: this.phone,
          password: this.pwd1,
          sms: this.sms,
        });
        this.$message.success('修改成功');
        this.$emit('cancel');
      } catch (error) {
        this.$message.error(error);
      } finally {
        this.login_loading = false;
      }
    },
  },
};
</script>
